import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { red } from "@material-ui/core/colors";
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  makeStyles,
  InputLabel,
} from "@material-ui/core";
import { selectCountry, getListofCountry, set } from "./countrySlice";
//import styles from "./Country.module.css";
import { selectLanguage } from "../language/languageSlice";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    minWidth: "100%",
    "&:hover": {
      boxShadow: "0 1px 1.5px rgba(0,0,0,0.16), 0 1px 1.5px rgba(0,0,0,0.23)",
    },
    transition: "box-shadow 0.75s",
  },
  textHilight: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
  },
}));

export function Country() {
  const classes = useStyles();
  const currentCountry = useSelector(selectCountry);
  const language = useSelector(selectLanguage);
  const listOfCountry = useSelector(getListofCountry);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <FormControl required className={classes.formControl} variant="outlined">
      <InputLabel id="Country-input-label">
        {" "}
        {language !== undefined
          ? language === "TH"
            ? "ส่งออกไปยังประเทศ"
            : "Export to Country"
          : "ส่งออกไปยังประเทศ"}
      </InputLabel>{" "}
      <Select
        labelId="Country-input-label"
        id="Country-input"
        color="secondary"
        value={currentCountry}
        onChange={(e) => {
          dispatch(set(e.target.value));
        }}
        className={classes.selectEmpty}
      >
        <MenuItem value="">
          <em> None </em>{" "}
        </MenuItem>{" "}
        {listOfCountry.map((Country) => {
          // console.log(Country);
          return (
            <MenuItem
              key={Country.Id}
              value={Country.Id}
              className={classes.textHilight}
            >
              {" "}
              {language === "TH" ? Country.NameTH : Country.Name}{" "}
            </MenuItem>
          );
        })}{" "}
      </Select>{" "}
      <FormHelperText> Required </FormHelperText>{" "}
    </FormControl>
  );
}
